// removed by extract-text-webpack-plugin
module.exports = {"frame":"_1MTdDc7dt9JQ5xYkR4_P2j","balance":"_3XKqa256MLmeJdI_ijHTvO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisWrapUnwrapUnwrap.scss
// module id = 1304
// module chunks = 0